import { useReselector } from '@/utils/sharedHooks'
import { selectYourTurnNumber } from '@/components/conversations/conversation.slice'

/**
 * Threads awaiting the customer's reply. Loaded by the nav's metadata call and
 * refreshed by the Messages list, so the badge never holds its own number.
 */
export const useAwaitingReplyCount = (enabled = true): number => {
  const count = useReselector(selectYourTurnNumber)
  return enabled ? count : 0
}
